var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"logo-search"},[_c('h1',{staticClass:"logo"},[_c('a',{staticClass:"logoImg",style:(_vm.logoPos),attrs:{"href":_vm.url}})]),_vm._v(" "),_c('city-mask',{attrs:{"hotKeyWords":_vm.hotKeyWords}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39e46ab5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common-components/Logotitle.vue
// module id = null
// module chunks = 